import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

// import pages
import Home from "./pages/Home";
import PropertyDetails from "./pages/PropertyDetails";
import PropertyType from "./pages/PropertyType";

import CardProperty from "./pages/CardContainer/CardProperty";

//dashboard
import DashboardHome from "./pages/Dashboard/DashboardHome";

//dashboard/property
import PropertyCreate from "./pages/Dashboard/Property/PropertyCreate";
import PropertyEdit from "./pages/Dashboard/PropertyEdit/PropertyEdit";
import PropertyList from "./pages/Dashboard/Property/PropertyList";

import Login from "./pages/Login";
import { AuthContextProvider } from "./context/authContext";
import PublicRoute from "./router/PublicRoute";
import PrivateRoute from "./router/PrivateRoute";
import PropertyFeatured from "./pages/Dashboard/Property/PropertyFeatured";
import SplashScreen from "./components/SplashScreen/SplashScreen";

// Configuración de Google Analytics
const GA_TRACKING_ID = "G-1EL9X996JJ";

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Cargar el script de Google Analytics
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_TRACKING_ID}');
    `;
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", { page_path: location.pathname });
    }
  }, [location]);

  return null;
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  return (
    <AuthContextProvider>
      {isLoading ? (
        <SplashScreen />
      ) : (
        <BrowserRouter>
          <GoogleAnalytics />
          <Routes>
            <Route path="/" element={<PublicRoute />}>
              <Route index element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/propiedad/:id" element={<PropertyDetails />} />
              <Route path="/tipo/:type" element={<PropertyType />} />
            </Route>

            <Route path="/dashboard/*" element={<PrivateRoute />}>
              <Route index element={<DashboardHome />} />
              <Route path="propiedades" element={<CardProperty />} />
              <Route path="propiedades/agregar" element={<PropertyCreate />} />
              <Route path="propiedades/ver" element={<PropertyList />} />
              <Route
                path="propiedades/destacadas"
                element={<PropertyFeatured />}
              />
              <Route path="propiedades/editar/:id" element={<PropertyEdit />} />
            </Route>
          </Routes>
        </BrowserRouter>
      )}
    </AuthContextProvider>
  );
}

export default App;
